import type { ArticleSummary } from './articles';

type BlogAuthor = {
  name: string;
  image: string;
  /** Original image dimensions and the desired square crop, in source pixels. */
  portrait: {
    width: number;
    height: number;
    crop: { x: number; y: number; size: number };
  };
};

const authorsByCategory = {
  Comparisons: {
    name: 'Ittai Svidler',
    image: '/blog/authors/ittai-svidler.webp',
    portrait: {
      width: 1024,
      height: 1488,
      crop: { x: 173, y: 170, size: 640 },
    },
  },
  Guides: {
    name: 'Jonah Erlich',
    image: '/blog/authors/jonah-erlich.webp',
    portrait: {
      width: 1024,
      height: 1536,
      crop: { x: 155, y: 280, size: 620 },
    },
  },
  'Wallet infrastructure': {
    name: 'Junhyuk (Jason) Bae',
    image: '/blog/authors/junhyuk-jason-bae.webp',
    portrait: {
      width: 1024,
      height: 1071,
      crop: { x: 150, y: 180, size: 740 },
    },
  },
} satisfies Record<ArticleSummary['category'], BlogAuthor>;

/** Keep each category's byline consistent across article pages and metadata. */
export function getArticleAuthor(
  category: ArticleSummary['category']
): BlogAuthor {
  return authorsByCategory[category];
}
